import { api } from "@common/api";
import type { Profile } from "../types/api";

// A player's own profile in play-api: what they chose to show. Everyone's
// comes back in the dashboard feed.

export type { Profile };

export async function myProfile(): Promise<Profile> {
  return api.get("/profile");
}

export async function saveMyProfile(profile: Profile): Promise<Profile> {
  return api.put("/profile", { body: profile });
}
